import { type ReactNode, type ElementType } from "react";
import { useInView } from "@/hooks/useInView";

interface RevealProps {
  children: ReactNode;
  as?: ElementType;
  className?: string;
  /** 0 = no delay, 1..5 = ~90ms steps */
  delay?: 0 | 1 | 2 | 3 | 4 | 5;
  threshold?: number;
}

export default function Reveal({
  children,
  as,
  className = "",
  delay = 0,
  threshold = 0.18,
}: RevealProps) {
  const Tag = (as ?? "div") as ElementType;
  const { ref, inView } = useInView<HTMLDivElement>({ threshold });
  const delayClass = delay > 0 ? ` delay-${delay}` : "";
  return (
    <Tag
      ref={ref}
      className={`lum-reveal${delayClass} ${inView ? "is-visible" : ""} ${className}`}
    >
      {children}
    </Tag>
  );
}